import BundledEditor from "./BundledEditor";
import React, {useRef, useEffect, useState} from "react";
import config from "../api/config";

const TextEditor = ({height, initialValue, onChange}) => {

    const editorRef = useRef(null);
    const [ editor, setEditor ] = useState(null);
    const [value, setValue] = useState('');

    useEffect(() => {
        setEditor(editorRef);
    }, []);

    return <BundledEditor
        onInit={(_evt, editor) => editorRef.current = editor}
        onEditorChange={(s) => onChange(s)}
        initialValue={initialValue}
        init={{
            height: height,
            menubar: false,
            images_upload_url: config.host + '/api/editor/file',
            plugins: [
                'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                'searchreplace', 'table', 'wordcount'
            ],
            toolbar: 'undo redo | blocks | image ' +
                'bold italic forecolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
    />

}

export default TextEditor;
